module.exports = __webpack_public_path__ + "img/icon_road_04.ddf3c253.png";